import React, {useContext, useEffect} from 'react';
import StepWizard from "react-step-wizard";

import Sidebar from "@/components/Sidebar";

import Welcome from "@/components/steps/Welcome";
import CreateAdmin from "@/components/steps/CreateAdmin";
import Finish from "@/components/steps/Finish";
import InstallerContext from "@/context/InstallerContext";
import LicenseVerification from "@/components/steps/LicenseVerification";
import {useTranslation} from "react-i18next";
import GameSelection from "@/components/steps/GameSelection";
import LoginProvider from "@/components/steps/LoginProvider";
import {loadSnapshot} from "@/lib/utils";

const SetupWizard = () => {
  const {data, setData} = useContext(InstallerContext);
  const {i18n} = useTranslation();
  
  useEffect(() => {
    // Get api key from url params
    const urlParams = new URLSearchParams(window.location.search);
    const apiKey = urlParams.get('api_key');
    if (apiKey) {
      setData({
        ...data,
        welcome: false,
        apiKey: apiKey,
      });
    }
  }, []);
  
  if (data.welcome) return <Welcome/>
  if (data.apiKey === null) return <LicenseVerification/>
  
  const snapshot = loadSnapshot();
  
  return (
      <StepWizard
          isLazyMount={true}
          nav={<Sidebar/>}
          initialStep={snapshot?.step || 1}
          className="relative bg-white flex overflow-hidden w-full"
      >
        <GameSelection/>
        <LoginProvider/>
        <CreateAdmin/>
        <Finish/>
      </StepWizard>
  );
};

export default SetupWizard;